module.exports = __webpack_public_path__ + "img/dp.c58e031b.png";